import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { TokenContext } from "../app/App";
import { getSavedSongs, SongCookie } from "../shared/utils/cookies.utils";
import { getSongById, ResponseStatus, Track } from "../spotify/spotify";
import { ReactComponent as BackArrowIcon } from "../media/back_arrow.svg";

export type ChosenSong = Track & {date: string}; // YYYY-MM-DD

const SongHistory: React.FC = () => {
    const navigate = useNavigate();
    const { token, setToken } = useContext(TokenContext);
    const [ status, setStatus ] = useState<"loaded" | "loading" | "success" | "error">("loading");
    const [ songHistory, setSongHistory ] = useState<ChosenSong[]>([]);

    const checkSavedSongs = async (accessToken: string) => {
        const songCookies = getSavedSongs();
        if (songCookies) {
            let songs: ChosenSong[] = [];
            for (let songCookie of songCookies) {
                const song = await getSongById(accessToken, songCookie.spotifyId);
                if (song === ResponseStatus.UnknownError || song === ResponseStatus.Unauthorized) {
                    setStatus("error");
                    return;
                }
                songs.push({date: songCookie.date, ...song});
            }
            setSongHistory(songs);
        } else {
            setSongHistory([]);
            setStatus("loaded");
        }
    }

    useEffect(() => {
        if (token) {
            checkSavedSongs(token.accessToken);
        } else {
            setStatus("error");
            return;
        }
    })

    return (
        <div className="column-centered">
            <div className='absolute top-3 left-3 cursor-pointer row align-center mx-bw-5' onClick={() => navigate(-1)}><BackArrowIcon /> <p>Back</p></div>
            <p className="my-3 text-lg">Previous Songs of the Day</p>
            {
                songHistory.length > 0 ?
                <div className="column track-list">
                    { 
                        songHistory.map(song => (
                            <div className="my-1 md:my-2" key={song.id}>
                                <p className="mb-2">{moment(song.date).format("dddd, MMM Do YYYY")}</p>
                                <div className="row align-center mx-bw-5">
                                    { song.album.images.length > 0 && <img src={song.album.images[0].url} alt="img" className="album-art-img" /> }
                                    <div className="flex-grow self-stretch column justify-center ml-1 md:ml-3">
                                        <p className="">{song.name} by <i>{song.artists.map(a => a.name).join(', ')}</i></p>
                                    </div>
                                    { 
                                        song.preview_url ?
                                        <audio controls className="ml-auto">
                                            <source src={song.preview_url} type="audio/mp3" />
                                        </audio> : 
                                        <p className="opacity-50 ml-auto">(no preview available)</p>
                                    }
                                </div>
                            </div>
                        ))
                    }
                </div> :
                <div className="column-centered">
                    <p className="my-5">You have not added any songs yet!</p>
                </div>
            }
        </div>
    )
}

export default SongHistory;
